export const regexExpressions = {
  pincode: /^[1-9][0-9]{5}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  panNumber: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  seasons: /([A-Za-z]+\s['’]\d{2})/g,
  name: /^[A-Za-z ]+$/,
};
